import { useAuth } from '@/features/Auth/state/AuthContext';
import { useActiveOrgRole } from '@/shared/contexts/SuperAdminOrgContext';
import { UserRole } from '../types/user-role';

/**
 * O usuário é administrador da organização ATIVA?
 *
 * `profiles.role` é global — nasceu quando um usuário pertencia a uma organização só,
 * então "role do usuário" e "role na organização" eram a mesma coisa. Com o vínculo
 * N:N (AB#84509) deixam de ser: quem é admin na própria organização entra como membro
 * comum em outra e não pode administrá-la. O backend já decide assim; se o front
 * continuar olhando a role global, ele oferece o menu administrativo dentro da
 * organização errada e o erro só aparece depois do clique.
 *
 * A role da organização ativa vem da lista de organizações. Enquanto ela não chega —
 * ou fora do provider, nas telas de auth — vale a role do perfil.
 *
 * @returns { isAdmin, isLoading }
 */
export const useIsAdmin = () => {
  const { user, loading } = useAuth();
  const activeOrgRole = useActiveOrgRole();

  // Superadmin é papel de PLATAFORMA, não de organização: administra qualquer uma,
  // sempre. Sai na frente para não depender da role que a lista devolveu — que, no
  // instante seguinte a um aceite de convite, ainda é o palpite otimista.
  if (user?.role?.toLowerCase() === UserRole.SUPERADMIN) {
    return { isAdmin: true, isLoading: loading };
  }

  const role = (activeOrgRole ?? user?.role ?? '').toLowerCase();
  const isAdmin = role === UserRole.ADMIN || role === UserRole.SUPERADMIN;

  return { isAdmin, isLoading: loading };
};
